module.exports = __webpack_public_path__ + "static/media/BPS_0473.157ed71b.jpg";